import { Bunting, Marigold, Sparkle } from "@/components/art/Poster";
import { useCourtyard } from "@/context/CourtyardContext";
import { PosterTitle } from "@/components/invite/Reveal";
import Ticket from "@/components/invite/Ticket";
import Countdown from "@/components/invite/Countdown";

export default function Hero({ ready }) {
  const { event: ev } = useCourtyard();
  return (
    <section id="top" className="paper relative overflow-hidden" aria-labelledby="hero-title">
      <div className="dots-navy pointer-events-none absolute inset-0 opacity-60" aria-hidden="true" />
      <Bunting className="relative h-[48px] w-full md:h-[64px]" width={1440} flags={26} />
      <div className="relative mx-auto grid max-w-7xl gap-12 px-5 pb-16 pt-6 sm:px-8 lg:grid-cols-12 lg:gap-10 lg:px-12 lg:pb-24 lg:pt-12">
        <div className="lg:col-span-7">
          <div className="flex flex-wrap items-center gap-3">
            <span className="pill">{ev.opening_eyebrow}</span>
            <span className="pill max-w-full bg-[var(--yellow)] leading-snug tracking-[0.1em] sm:tracking-[0.16em]" data-testid="hero-hosts">Hosted by {ev.host_names}</span>
          </div>
          <div className="relative mt-5">
            <PosterTitle id="hero-title" text={ev.title} ready={ready} className="text-[clamp(3.6rem,17vw,8rem)]" />
            <Sparkle className="absolute -left-3 -top-3 w-7" />
          </div>
          <p className="font-serif-i mt-5 text-3xl leading-tight sm:text-4xl">{ev.welcome_heading}</p>
          <Countdown />
          <Marigold className="mt-8 hidden w-12 lg:block" />
        </div>
        <div className="lg:col-span-5 lg:pt-6">
          <Ticket />
        </div>
      </div>
    </section>
  );
}
